// Components==============
import React, { useState } from 'react';
import './PortfolioCard.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/pro-solid-svg-icons';
import { NavLink } from 'react-router-dom';
// =========================

export default function PortfolioCard({
  item,
  width,
}: {
  item?: PortfolioEntity;
  width?: number;
}) {
  const [copyButtonIsClicked, setCopyButtonIsClicked] = useState(false);

  function copyShareButton(e: React.MouseEvent<HTMLDivElement>) {
    e.stopPropagation();
    navigator.clipboard.writeText(
      `learntogroow.com/publiek-portfolio/${item?.share_code}`
    );
    setCopyButtonIsClicked(true);
    setTimeout(() => {
      setCopyButtonIsClicked(false);
    }, 2000);
  }

  return (
    <div styleName="container">
      <NavLink
        to={`/publiek-portfolio/${item?.share_code}`}
        target="_blank"
        style={{ zIndex: 0 }}
      >
        <div styleName="wrapper">
          <div styleName="left">
            <p styleName="title">{item?.name}</p>
            <p styleName="link" style={{ width }}>
              learntogroow.com/publiek-portfolio/
              {item?.share_code}
            </p>
          </div>
        </div>
      </NavLink>
      <div
        styleName={copyButtonIsClicked ? 'circle clicked' : 'circle'}
        onClick={copyShareButton}
      >
        <FontAwesomeIcon icon={faCopy} />
      </div>
    </div>
  );
}
